<template>
  <v-app id="app">
    <RawHansong  />
  </v-app>
</template>

<script>
import RawHansong from './components/RawHansong'

export default {
  name: 'app',
  components: {
    RawHansong
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
/*  text-align: center; */
  color: #2c3e50;
  margin-top: 60px;
}
</style>
